import { Component, Directive, Input, ViewEncapsulation } from '@angular/core';
import { ObjectUtils } from '../../../../utils/object.utils';

@Component({
  selector: 'field-holder',
  templateUrl: './field-holder.component.html',
  styleUrls: ['./field-holder.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FieldHolderComponent {

  readonly isEmpty = ObjectUtils.isEmpty;

  @Input() editMode: boolean;
  @Input() label: string;
  @Input() value: string;
  @Input() condition = true;
  @Input() dropdown = false;

}

@Directive({
  selector: '[fieldHolderContent]',
})
export class FieldHolderContentDirective {
}
